import times from "lodash/times";
import { DATE_FORMATS } from "../../../../../constants";
import MonthExercise from "../../../../dashboard/calendar/components/MonthExercise";

const { DATE_DAY_FORMAT } = DATE_FORMATS;

const Exercises = ({
  exercises,
  supersets,
  withWeight,
  fromMetric,
  units,
  round,
  expanded,
  date,
  intensityMeasure,
  isRiR,
  mobile = false,
  athlete
}) => (
  <div className={`exercises-frame${expanded ? " expanded" : ""}`}>
    {times(exercises.length, (idx) => {
      const exercise = exercises[idx];
      if (!exercise) return null;
      return (
        <MonthExercise
          key={exercise._id}
          exercise={exercise}
          supersets={supersets}
          withWeight={withWeight}
          fromMetric={fromMetric}
          units={units}
          round={round}
          expanded={expanded}
          date={date.format(DATE_DAY_FORMAT)}
          intensityMeasure={intensityMeasure}
          isRiR={isRiR}
          mobile={mobile}
          showCopyButton={true}
          athlete={athlete}
        />
      );
    })}
  </div>
);

export default Exercises;
